import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/reallocate`;

export const ROUTE: RouteDefinition = `${baseRoute}/reallocate`;

export const URL = (): RouteDefinition => `${baseRoute}/reallocate`;
